import { render, staticRenderFns } from "./hot-chart.vue?vue&type=template&id=6e484e2c&scoped=true"
import script from "./hot-chart.vue?vue&type=script&lang=js"
export * from "./hot-chart.vue?vue&type=script&lang=js"
import style0 from "./hot-chart.vue?vue&type=style&index=0&id=6e484e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e484e2c",
  null
  
)

export default component.exports